<template>
  <div class="pa-3">

    <v-row justify="center">
      <v-col cols="12" lg="6">
        <div class="suggestedArea emptyStateList">
          <div class="text-center">
            <img src="../../assets/image/user-journey/OBJECTS.svg" alt="">
            <div class="titleEmpty">
              متاسفانه در حال حاضر تراپیست مناسبی برای شما پیدا نشد.
            </div>

            <div class="actionArea px-3">
              <v-row justify="center">
                <v-col cols="6" lg="4">
                  <v-btn class="outLineSubmitBtn" outlined @click="backToMatchMaking" elevation="0">
                    به روز رسانی ترجیحات
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <!--    <v-row class="flex-grow-1 " justify="center " :class="$vuetify.breakpoint.mdAndUp && 'mt-10' ">-->
    <!--      <v-col cols="12" md="8" lg="5">-->

    <!--      </v-col>-->
    <!--    </v-row>-->
  </div>
</template>

<script>


export default {
  props: {
    therapists: Array,
  },
  data() {
    return {}
  },
  beforeDestroy() {
    this.$emitEvent('changeVisibiltySeekback', true)
  },
  methods: {
    backToMatchMaking() {
      // this.$emit('changeStateFlow', {
      //   state: 'matchMaking',
      // })
      // this.$emitEvent('changeVisibiltySeekback', true)
      localStorage.removeItem('set_session_token')
      localStorage.removeItem('psychology_field_id')
      localStorage.removeItem('match_additional_data')
      setTimeout(() => {
        location.reload();
      }, 500)
    },

  },
  mounted() {
    this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 90)
    this.$emitEvent('changeVisibiltySeekback', false)
  },
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 1000px) {
  .suggestedArea {
    margin-top: 40px !important;
    width: 90% !important;
    margin: 0px auto;
  }

}

.titleEmpty {
  color: #212121;
  text-align: center;
  margin-top: 50px;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.descEmpty {
  color: #212121;
  text-align: center;

  /* Body/Large/Medium18 */
  font-size: 18px;
  margin-top: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.submitBtn {
  border-radius: 8px;
  background: #39C990 !important;
  width: 100%;
  height: 48px !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 0px;
  color: white !important;
}

.outLineSubmitBtn {
  display: flex;
  width: 100%;
  height: 48px !important;
  padding: 0 19.55px;
  justify-content: center;

  border-radius: 8px;
  border: 1px solid #39C990;
  align-items: center;
  color: #39C990 !important;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}
.suggestedArea {
  margin-top: 90px;
}
</style>